import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

export const themeConfigs = resolveConfig(tailwindConfig).theme;

export const themeTabs = {
   tablist: {
      variant: { underline: 'border-b-0 pl-8' },
      tabitem: {
         variant: {
            underline: { active: { on: 'border-b-2 border-blue-600 text-blue-600 focus:ring-0 px-8', off: 'border-blue-600 focus:ring-0 px-8' } },
         },
      },
   },
};

export const themeTooltip = {
   target: 'w-full overflow-hidden text-ellipsis whitespace-nowrap',
   base: 'bg-blue-600 ',
};

export const themeModal = {
   content: {
      base: 'relative w-full p-4 md:h-auto',
   },
};
